import React from "react";
import ReactDOM from "react-dom";
import singleSpaReact from "single-spa-react";
import App from "./App";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import { basicLogger } from "launchdarkly-js-client-sdk";
import { getLDClientKey } from "./components/supportFunctions/FeatureFlags";

const loadRootComponent = async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: getLDClientKey()!,
    reactOptions: {
      useCamelCaseFlagKeys: false,
    },
    options: {
      streaming: true,
      logger: basicLogger({ level: "none" }),
    },
  });

  return function () {
    return (
      <React.StrictMode>
        <LDProvider>
          <App />
        </LDProvider>
      </React.StrictMode>
    );
  };
};

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  loadRootComponent,
  errorBoundary(err, info, props) {
    // Customize the root error boundary for your microfrontend here.
    return null;
  },
});

export const { bootstrap, mount, unmount } = lifecycles;
